import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country } from "../models/country.model";
import { DeliveryOption } from "../models/delivery_option.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class DeliveryOptionService extends GraphQLService<DeliveryOption> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  availableDeliveryOptions(country: Country): Observable<DeliveryOption[]> {
    return this.findAll(`{ deliveryOptions(country: "${ country.iso }") { id toKg deliveryMethod showLocalCustomsNote dutyFeeMessages mobilePhoneNumberRequired currencyPrices { currency exchangeRate netPrice } } }`)
  }

}
